import React from 'react';

const DOMAINS = [
  { key: 'space_weather', label: 'MAGNETOSPHERE', icon: 'M' },
  { key: 'solar_activity', label: 'HELIOSPHERE', icon: 'S' },
  { key: 'orbital_tracking', label: 'ORBITAL', icon: 'O' },
  { key: 'astronomy_events', label: 'ASTRONOMY', icon: 'A' },
  { key: 'cosmic_background', label: 'COSMIC', icon: 'C' },
];

export default function DomainCoverageWidget({ scoring, domainCoverage }) {
  const affected = new Set(scoring?.affectedDomains || []);
  const staleFlags = scoring?.staleFlags || {};

  // Check if any source for a domain is stale
  const domainStale = {};
  const srcDomain = {
    noaa_swpc: 'space_weather', celestrak: 'orbital_tracking',
    iss_tracker: 'orbital_tracking', nasa_donki: 'solar_activity', nasa_apod: 'astronomy_events',
  };
  for (const [src, isStale] of Object.entries(staleFlags)) {
    const dom = srcDomain[src];
    if (dom && isStale) domainStale[dom] = true;
  }

  return (
    <div className="orion-dcw" data-testid="domain-coverage-widget">
      {DOMAINS.map(d => {
        const count = domainCoverage?.[d.key] || 0;
        const isAffected = affected.has(d.key);
        const isStale = domainStale[d.key];
        const isLive = count > 0 && !isAffected && !isStale;

        let status = 'none';
        let statusColor = '#27272A';
        if (isLive) { status = 'LIVE'; statusColor = '#34C759'; }
        else if (isStale) { status = 'STALE'; statusColor = '#FF9F0A'; }
        else if (isAffected) { status = 'AFFECTED'; statusColor = '#FF3B30'; }
        else if (count > 0) { status = 'PARTIAL'; statusColor = '#FF9F0A'; }

        return (
          <div key={d.key} className="orion-dcw-row" data-testid={`coverage-${d.key}`}>
            <span className="orion-dcw-icon" style={{ color: isLive ? '#00E5FF' : '#52525B' }}>{d.icon}</span>
            <span className="orion-dcw-label">{d.label}</span>
            <div className="orion-dcw-bar">
              <div className="orion-dcw-bar-fill" style={{
                width: `${Math.min(count * 25, 100)}%`,
                background: statusColor,
              }} />
            </div>
            <span className="orion-dcw-status" style={{ color: statusColor }}>{status || '—'}</span>
          </div>
        );
      })}
    </div>
  );
}
